<template>
  <div>
    <a-form-item class="btn-gropu-gps" :label="locationData.label" required v-bind="itemLayout || $store.state.base_itemLayout">
      <a-input-group compact>
        <a-form-item v-for="(item, index) of locationData.subList" :key="index">
          <a-input v-decorator="item.props" :placeholder="item.placeholder" readOnly/>
        </a-form-item>

        <a-form-item>
          <a-button @click="openModal" type="primary">点击定位</a-button>
        </a-form-item>
      </a-input-group>
    </a-form-item>

    <!--gps定位的弹窗-->
    <a-modal
      title=""
      :visible="visible"
      @ok="confirm"
      @cancel="cancelModal"
      okText="确认"
      cancelText="取消"
      destroyOnClose
      :width="1000"
      centered
      :maskClosable="false"
      :keyboard="false"
      :closable="false"
      :bodyStyle="{padding: '10px'}"
    >
      <div class="amap-box" id="container">
      </div>
      <div class="amap-search">
        <span>搜索：</span>
        <input id="tipinput" placeholder="请输入关键字"/>
      </div>
      <div class="output">
        <p>
          <span class="title">经纬度：</span>
          <span class="value">{{positionResult[inputKey.lng]}},{{positionResult[inputKey.lat]}}</span>
        </p>
        <p>
          <span class="title">地址：</span>
          <span class="value">{{positionResult[inputKey.address]}}</span>
        </p>
        <p>
          <span class="title">最近的POI：</span>
          <span class="value">{{positionResult.PIO}}</span>
        </p>
      </div>
    </a-modal>
  </div>
</template>

<script>
/* global AMap AMapUI */
export default {
  name: 'location',
  props: {
    form: {
      type: Object,
      default: () => {}
    },
    lngLat: {
      default: () => ''
    },
    position: {
      default: () => ''
    },
    inputKey: {
      type: Object,
      default: () => {}
    },
    locationData: {
      type: Object,
      default: () => {}
    },
    itemLayout: {
      type: Object
    }
  },
  data () {
    return {
      invalidLocation: false,
      location: '',
      visible: false,
      map: {},
      positionResult: {}
    };
  },
  mounted () {
  },
  methods: {
    /** 关闭弹窗 */
    cancelModal () {
      this.visible = false;
      console.log('confirm cancel: ', this.invalidLocation);
      if (this.positionResult && !this.invalidLocation) {
        this.setLocation({...this.positionResult});
      }
    },
    setLocation (inputVal) {
      this.location = [inputVal[this.inputKey.lng], inputVal[this.inputKey.lat]];
    },
    /** 所属区域或小区的城市范围已更改 */
    positionChanged () {
      this.location = '';
      this.lngLat.splice(0, 2);
    },
    openModal () {
      this.visible = true;
      this.initAMap();
    },
    confirm () {
      if (this.positionResult) {
        this.lngLat.splice(0, 2); // 重置后台返回的经纬度
        let inputVal = {...this.positionResult};
        let index = this.positionResult[this.inputKey.address].indexOf(this.position);
        if (index < 0) {
          this.$message.error('请选取区域范围内经纬度');
          this.invalidLocation = true;
          return;
        }

        delete inputVal.PIO;
        for (let item in inputVal) {
          if (item === 'no_address') { // 当输入框不需要输入address时，key为no_address
            delete inputVal.no_address;
          }
        }
        if (!this.form) {
          this.$emit('transferValue', inputVal);
        } else {
          this.form.setFieldsValue(inputVal);
        }
        this.setLocation(inputVal);
      } else {
        this.$message.error('获取定位失败！');
      }
      this.map.destroy();
      this.visible = false;
    },
    /* 初始化地图 */
    initAMap () {
      this.$nextTick(() => {
        AMapUI.loadUI(['misc/PositionPicker'], (PositionPicker) => {
          this.map = new AMap.Map('container', {
            resizeEnable: true,
            scrollWheel: true
          });

          console.log('location: ', this.location);
          console.log('lngLat: ', this.lngLat);
          console.log('position: ', this.position);
          if (this.location) { // 三个变量判断的顺序不断变
            this.map.setZoomAndCenter(15, this.location);
            this.location = '';
          } else if (this.lngLat && this.lngLat.length) {
            this.map.setZoomAndCenter(15, this.lngLat);
          } else if (this.position && typeof this.position === 'string') {
            this.map.setCity(this.position, () => {
              this.map.setZoom(15);
            });
          }
          // this.map.setBounds(this.map.getBounds());

          let positionPicker = new PositionPicker({
            mode: 'dragMap',
            map: this.map
          });
          positionPicker.on('success', (result) => {
            this.positionResult = {
              [this.inputKey.lat]: result.position.lat,
              [this.inputKey.lng]: result.position.lng,
              [this.inputKey.address]: result.address,
              PIO: result.nearestPOI
            };
          });
          positionPicker.on('fail', (result) => {
            this.positionResult = {};
          });
          positionPicker.start();
          this.map.panBy(0, 1);

          this.map.addControl(new AMap.ToolBar({
            liteStyle: true
          }));

          let auto = new AMap.Autocomplete({input: 'tipinput'});
          let placeSearch = new AMap.PlaceSearch({map: this.map});

          AMap.event.addListener(auto, 'select', function (e) {
            placeSearch.setCity(e.poi.adcode);
            placeSearch.search(e.poi.name);
          });
        });
      });
    }
  }
};
</script>

<style lang="scss">
/*S- gps定位*/
.amap-box {
  width: 100%;
  height: 550px;
}
.amap-search {
  position: absolute;
  z-index: 10;
  top: 25px;
  left: 20px;
  input {
    border: 1px solid #d9d9d9;
    height: 26px;
    border-radius: 2px;
  }
}
.output {
  margin: 10px 0 0 10px;
  p {
    line-height: 24px;
    .title {
      font-weight: bold;
      color: #444;
    }
  }
}
/*E- gps定位*/
</style>
